import { MeshLambertMaterial, MeshMatcapMaterial, MeshStandardMaterial } from 'three';
import { Materials, SceneSlice } from './store.d'
import create, { StateCreator } from 'zustand'
import { devtools } from 'zustand/middleware'
import { createTerrainSlice } from '../../c.managers/TerrainManager/store'
import { TerrainSlice } from '../../c.managers/TerrainManager/store.d'
import { createCharactersSlice } from './../../c.managers/CharactersManager/store'
import { CharactersSlice } from './../../c.managers/CharactersManager/store.d'
import { GLTFActions } from '../../f.assets/animations/CharactersAnimations'
import { createLevelSlice } from '../../c.managers/LevelManager/store'
import { LevelSlice } from '../../c.managers/LevelManager/store.d'


// store array reference at module level to avoid Redux to serialize many objects and crash
let gameElementsAnimationActions = new Map<string, GLTFActions>()
let materialsCache = new Map<string, Materials>()

const SceneInitialState = {}

const createSceneSlice: StateCreator<SceneSlice, [['zustand/devtools', never]], [], SceneSlice> = set => ({
  ...SceneInitialState,
  addGameElementsAnimationActions: (uuid: string, element: GLTFActions) => {
    gameElementsAnimationActions.set(uuid, element)

    set({}, false, { type: 'addGameElementsAnimationActions' })
  },
  getGameElementsAnimationActions: () => gameElementsAnimationActions,
  addMaterial: (uuid: string, element: Materials) => {
    materialsCache.set(uuid, element)

    set({}, false, { type: 'addMaterial' })
  },
  getMaterials: () => materialsCache,
})

export type GameSceneStoreStype = SceneSlice & TerrainSlice & CharactersSlice & LevelSlice
export const useSceneStore = create<GameSceneStoreStype>()(
  devtools(
    (...a) => ({
      ...createSceneSlice(...a),
      ...createTerrainSlice(...a),
      ...createCharactersSlice(...a),
      ...createLevelSlice(...a),
    }),
    { name: 'GameScene' },
  ),
)
// helper to listening a Zustand state change
export const onStateChange = (
  compare: (state: GameSceneStoreStype) => any,
  callback: (state: GameSceneStoreStype) => void,
) => {
  const unsubs = useSceneStore.subscribe((state, prevState) => {
    if (compare(state) !== compare(prevState)) {
      callback(state)
      unsubs()
    }
  })
  return unsubs
}
